var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRtvReason(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59966_50668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1411 4.49774L7.11084 7.97935L1.07812 4.49219",
    stroke: "#6A6C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10938 7.97656V11.2119V14.4473",
    stroke: "#6A6C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82825 14.7496C7.38335 15.0065 6.83521 15.0065 6.39031 14.7496L1.60178 11.9851C1.15688 11.7282 0.882812 11.2534 0.882812 10.7397V5.21041C0.882812 4.69669 1.15688 4.22199 1.60178 3.96512L6.39031 1.20046C6.83521 0.943596 7.38335 0.943596 7.82825 1.20046L12.6168 3.96512C12.9032 4.13047 13.1188 4.38609 13.2361 4.68428C13.2651 4.75812 13.2881 4.83457 13.3047 4.9129",
    stroke: "#6A6C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3044 12.3416L8.98438 10.2216L11.3044 8.10156",
    stroke: "#6A6C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67188 10.0156H12.6474C12.9543 10.0156 13.2583 10.0787 13.5419 10.2014C13.8255 10.324 14.0832 10.5037 14.3002 10.7303C14.5173 10.9569 14.6895 11.2258 14.8069 11.5219C14.9244 11.8179 14.9849 12.1352 14.9849 12.4556C14.9849 12.7761 14.9244 13.0933 14.8069 13.3894C14.6895 13.6854 14.5173 13.9544 14.3002 14.181C14.0832 14.4075 13.8255 14.5873 13.5419 14.7099C13.2583 14.8325 12.9543 14.8956 12.6474 14.8956H11.1599",
    stroke: "#6A6C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59966_50668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtvReason);
export default __webpack_public_path__ + "static/media/rtvReason.19ea674b2241c97994f45a2261777c69.svg";
export { ForwardRef as ReactComponent };